/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  // Solución directa: remueve los event listeners del elemento ya existente
  document.addEventListener('DOMContentLoaded', function() {
      const zoomImages = document.querySelector('zoom-images');
      
      if (zoomImages) {
          // Clona el elemento para remover todos los event listeners
          const newZoomImages = zoomImages.cloneNode(true);
          zoomImages.parentNode.replaceChild(newZoomImages, zoomImages);
          
          console.log('✅ Drag/Swipe eliminado de zoom-images');





          // Opción C: Zoom solo en desktop, desactivado completamente en móvil
          (function() {
              'use strict';
              
              function initZoom() {
                  // Detectar si es dispositivo móvil/táctil
                  const isMobile = window.matchMedia('(hover: none) and (pointer: coarse)').matches;
                  
                  // Si es móvil, no hacer nada (opción C)
                  if (isMobile) return;
                  
                  // Seleccionar todos los contenedores de imágenes
                  const wrappers = document.querySelectorAll('zoom-images .image-wrapper');
                  
                  if (wrappers.length === 0) return;
                  
                  // Aplicar efecto zoom a cada wrapper
                  wrappers.forEach(wrapper => {
                      const img = wrapper.querySelector('img');
                      let timeoutId = null;
                      
                      if (!img) return;
                      
                      // Mouse move: actualizar origen del zoom y aplicar escala
                      wrapper.addEventListener('mousemove', function(e) {
                          // Limpiar timeout anterior si existe
                          if (timeoutId) {
                              clearTimeout(timeoutId);
                              timeoutId = null;
                          }
                          
                          const rect = wrapper.getBoundingClientRect();
                          const x = ((e.clientX - rect.left) / rect.width) * 100;
                          const y = ((e.clientY - rect.top) / rect.height) * 100;
                          
                          img.style.transformOrigin = `${x}% ${y}%`;
                          img.style.transform = 'scale(1.3)';
                      });
                      
                      // Mouse leave: restaurar imagen después de 400ms
                      wrapper.addEventListener('mouseleave', function() {
                          timeoutId = setTimeout(function() {
                              img.style.transform = 'scale(1)';
                              timeoutId = null;
                          }, 100);
                      });
                  });
              }
              
              // Inicializar cuando el DOM esté listo
              if (document.readyState === 'loading') {
                  document.addEventListener('DOMContentLoaded', initZoom);
              } else {
                  initZoom();
              }
          })();
      }
  });
  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
